import { useTranslation } from "react-i18next";
import Button from "../components/controls/Button";
import NotFoundImg from "../images/stoppineapple.png"; // ou une autre image dédiée

export default function NotFoundPage() {
  const { t } = useTranslation();

  return (
    <main className="min-h-screen flex flex-col items-center justify-center p-6 bg-gradient-to-b from-[#fff7e6] to-white">
      <section className="w-full max-w-md text-center">
        {/* Halo pulse discret (pas de 'bounce') */}
        <div className="relative mx-auto w-44 sm:w-56 aspect-square">
          <div className="absolute inset-0 rounded-full bg-[#fff3af] blur-2xl opacity-70 animate-pulse" />
          <div className="absolute inset-0 rounded-full border border-[#94d3cc] opacity-30" />
          <img
            src={NotFoundImg}
            alt={t("notFound.imageAlt")}
            className="relative z-10 w-full h-full object-contain drop-shadow"
          />
        </div>

        <h1 className="mt-6 text-3xl font-bold" style={{ color: "#C85A2C" }}>
          {t("notFound.title")}
        </h1>

        <p
          className="mt-3 text-base leading-relaxed"
          style={{ color: "#B35C38" }}
        >
          {t("notFound.subtitle")}
        </p>

        <p className="mt-4 text-sm opacity-80">{t("notFound.description")}</p>

        <div className="mt-6 flex flex-col sm:flex-row gap-3 justify-center">
          <Button as="a" size="lg" href="/" fullWidth className="sm:w-auto">
            {t("notFound.cta.home")}
          </Button>
          <Button
            as="a"
            size="lg"
            href="/boutique"
            fullWidth
            className="sm:w-auto"
          >
            {t("notFound.cta.shop")}
          </Button>
        </div>
      </section>
    </main>
  );
}
